import styled from '@emotion/styled';
import { typography } from '@landsbankinn/ui';
import type { ReactNode } from 'react';
import React from 'react';

const SvgContainer = styled.div`
  display: flex;
  width: 24px;
  justify-content: center;
  align-items: center;
  margin-right: 14px;
`;

const ListItem = styled.div`
  display: flex;
  align-items: center;
  padding-bottom: 28px;
`;

const Text = styled.p<{ bold?: boolean }>`
  ${(props) => (props.bold ? typography.body : typography.bodySmall)};
  ${(props) => (props.bold ? 'font-weight: 500;' : '')}
`;

interface IProps {
  text: string;
  svg: ReactNode;
  bold?: boolean;
}

export function CardItem({ text, svg, bold }: IProps) {
  return (
    <ListItem>
      <SvgContainer>{svg}</SvgContainer>
      <Text bold={bold}>{text}</Text>
    </ListItem>
  );
}
